import styles from "./index.module.css";
import React, { useState, useEffect } from "react";

import Button, { ButtonPurpose } from "shared/Button";
import TextInput from "shared/@forms/TextInput";
import EmailInput from "shared/@forms/EmailInput";
import PhoneInput from "shared/@forms/PhoneInput";
import { Form } from "shared/@forms/Form";

import { Ok, Danger, Lock } from "react-ikonate";
import Loader from "shared/Loader";

// Editable fields:
//  - First name
//  - Last name
//  - Phone number
//  - Email address

export default function DSInfoEdit({ data, disabled, onSubmit, onCancel }) {
  //const [editData, setEditData] = useState(data);

  const [name, setName] = useState(data.iboInfo.name);
  const [email, setEmail] = useState(data.iboInfo.email);

  useEffect(() => {
    setName(data.iboInfo.name);
    setEmail(data.iboInfo.email);
  }, [data]);

  return (
    <div className={styles.container}>
      <Form
        onSubmit={(e) => {
          onSubmit({name: name, email: email});
        }}
      >
        <div className={styles.splitGroup}>
          <div className={styles.inputGroup}>
            <label htmlFor="name">First Name</label>
            <TextInput
              id="name"
              required={true}
              disabled={disabled}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className={styles.inputGroup}>
            <label htmlFor="email">Email</label>
            <EmailInput
              id="email"
              required={true}
              disabled={disabled}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>
        <div className={styles.actions}>
          {disabled && (
            <>
            <Loader size={50} />
            </>
          )}
          
          {!disabled && (
            <>
              <Button purpose={ButtonPurpose.save} disabled={disabled}>
                Save Info
              </Button>

              <Button
                disabled={disabled}
                onClick={(e) => {
                  e.preventDefault();
                  onCancel();
                }}
              >
                Cancel
              </Button>
            </>
          )}
        </div>
      </Form>
    </div>
  );
}
